import React from 'react';
import './Footer.css'; // Link to the CSS file

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} All rights reserved.</p>
    
    
    </footer>
  );
};

export default Footer;
